module.exports = __webpack_public_path__ + "static/media/html.9cf4a14c.png";